import * as React from 'react';
import styled from 'styled-components';
import { __ } from 'react-i18n';
import { rem } from 'polished';

interface Props {
  message: string;
}

export function TopInfoBanner({ message }: Props) {
  return <Wrapper dangerouslySetInnerHTML={{ __html: message }} />;
}

const Wrapper: any = styled.div`
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: ${rem(16)};
  width: 100%;
  text-align: center;
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.tertiary};

  & > p {
    margin: 0;
  }

  ${({ theme }) => theme.mediab.l925`
    display: none;
  `};
`;
